module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA2AQMAAAChqWhXAAAABlBMVEUAAAD///+l2Z/dAAAAAXRSTlMAQObYZgAAABVJREFUGNNj+A8BH0hjDH4w6i8kBgA0ho5jAzo5KwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/wap_more.png
// module id = 3Z9s
// module chunks = 1